import { ZNSTemplateEditor } from './zns-template-editor.tsx'

export default function CreateTemplate() {
  return <ZNSTemplateEditor />
}
